import axios from "axios";
export function uploadUrl(url) {
  if (url == "") return "";

  var imgurl = process.env.imgUrl;

  return imgurl + "/" + url;
}

export function sourceUrl(url) {
  if (url == "") return "";

  var sourceUrl = process.env.sourceUrl;

  return sourceUrl + "/" + url;
}

// url截取
export function getInfoByUrl(url) {
  var urlinfo = {};
  var search = url.split("?");
  if (search.length > 1) {
    var searchpara = search.pop();
    var paras = searchpara.split("&");
    var urlParas = [];
    for (var i = 0, l = paras.length; i < l; i++) {
      var item = paras[i].split("=");
      if (item.length > 1) {
        urlParas.push({
          Key: item[0],
          Value: decodeURI(item[1]),
        });
        urlinfo[item[0]] = decodeURI(item[1]);
      }
    }
  }
  return urlinfo;
}
// 时间格式化
export function date(time, cFormat) {
  if (arguments.length === 0) {
    return null;
  }

  if (time == 0) return "-";

  if ((time + "").length === 10) {
    time = +time * 1000;
  }

  var format = cFormat || "{y}-{m}-{d} {h}:{i}:{s}";
  var date = new Date();
  if (typeof time === "object") {
    date = time;
  } else {
    date = new Date(parseInt(time + ""));
  }
  var formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay(),
  };

  var time_str = format.replace(
    /{(y|m|d|h|i|s|a)+}/g,
    function(result, key) {
      var value = formatObj[key];
      if (key === "a")
        return ["一", "二", "三", "四", "五", "六", "日"][value - 1];
      if (result.length > 0 && value < 10) {
        value = "0" + value;
      }
      return value || 0;
    }
    // (result, key) => {

    // }
  );
  return time_str;
}

export function acTiveArrStringFun(obj) {
  var arr = [];
  if (obj != null && obj.length !== 0) {
    for (var i = 0; i < obj.length; i++) {
      arr.push(obj[i]);
    }
  }
  return arr.toString();
}


export function Imgsuffix(img) {
  var suffix = img.split("/");
  var Imagesuffix = suffix[1];
  if (!/\.(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(Imagesuffix)) {
    return Imagesuffix;
  }
}

export function processUrl() {
  if(process.env.NODE_ENV === 'development'){
    return 'http://cmali.com'
  }else {
    return ''
  }
}

export function backUrl() {
  if(process.env.NODE_ENV === 'development'){
    return 'http://cm.cn'
  }else {
    return 'https://www.clothesmake.com.cn'
  }
}
/**
 * @desc 格式化日期字符串
 * @param { Nubmer} - 时间戳
 * @returns { String } 格式化后的日期字符串
 */
export function formatDate(timestamp) {
  // 补全为13位
  let arrTimestamp = (timestamp + '').split('');
  for (let start = 0; start < 13; start++) {
    if (!arrTimestamp[start]) {
      arrTimestamp[start] = '0';
    }
  }
  timestamp = arrTimestamp.join('') * 1;
  let minute = 1000 * 60;
  let hour = minute * 60;
  let day = hour * 24;
  let month = day * 30;
  let now = new Date().getTime();
  let diffValue = now - timestamp;
  // 如果本地时间反而小于变量时间
  if (diffValue < 0) {
    return '不久前';
  }
  // 计算差异时间的量级
  let monthC = diffValue / month;
  let weekC = diffValue / (7 * day);
  let dayC = diffValue / day;
  let hourC = diffValue / hour;
  let minC = diffValue / minute;
  // 数值补0方法
  let zero = function (value) {
    if (value < 10) {
      return '0' + value;
    }
    return value;
  };
  // 使用
  if (monthC > 4) {
    // 超过1年，直接显示年月日
    return (function () {
      let date = new Date(timestamp);
      return date.getFullYear() + '年' + zero(date.getMonth() + 1) + '月' + zero(date.getDate()) + '日';
    })();
  } else if (monthC >= 1) {
    return parseInt(monthC) + '月前';
  } else if (weekC >= 1) {
    return parseInt(weekC) + '周前';
  } else if (dayC >= 1) {
    return parseInt(dayC) + '天前';
  } else if (hourC >= 1) {
    return parseInt(hourC) + '小时前';
  } else if (minC >= 1) {
    return parseInt(minC) + '分钟前';
  }
  return '刚刚';
}

var filters = {
  uploadUrl: uploadUrl,
  getInfoByUrl: getInfoByUrl,
  date: date,
  formatDate: formatDate,
  sourceUrl: sourceUrl,
  processUrl: processUrl,
  backUrl: backUrl
};

export default filters;



// WEBPACK FOOTER //
// ./src/assets/globle.js